import { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import { NavLink } from "react-router-dom";
import { getLanguageContent } from "../../utils/language/languageSelector";
import { PUBLIC_NAV_BAR_SCHEMA } from "../../utils/schemas/language/components/publicnavbarSchema";
import "../../styles/v2/components/navigation.css";

function PublicNavBarV2({ langKey }) {
  const isAuthenticated = useSelector((state) => state.auth.isAuthenticated);
  const [isNotificationActive, setIsNotificationActive] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  const content = getLanguageContent(PUBLIC_NAV_BAR_SCHEMA, langKey);

  // Lock body scroll when mobile menu is open
  useEffect(() => {
    if (isMobileMenuOpen) {
      document.body.style.overflow = "hidden";
      document.documentElement.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "";
      document.documentElement.style.overflow = "";
    }

    // Cleanup on unmount
    return () => {
      document.body.style.overflow = "";
      document.documentElement.style.overflow = "";
    };
  }, [isMobileMenuOpen]);

  // Authenticated user navbar
  if (isAuthenticated) {
    return (
      <nav className="public-nav-v2 authenticated">
        <div className="public-nav-v2-content">
          <NavLink to="/" className="public-nav-v2-logo">
            <img
              src={`${process.env.PUBLIC_URL}/images/logo_dark_blue.svg`}
              alt="Plaintr"
              height="30"
            />
          </NavLink>
          <div className="public-nav-v2-actions">
            <NavLink
              to="/"
              className="public-nav-v2-icon-link"
              data-icon="folder_open"
              title="Filings"
            >
              <span className="mFont">folder_open</span>
            </NavLink>
            <NavLink
              to="/notifications"
              className="public-nav-v2-icon-link"
              data-icon={
                isNotificationActive ? "notifications_active" : "notifications"
              }
              title="Notifications"
            >
              <span className="mFont">
                {isNotificationActive
                  ? "notifications_active"
                  : "notifications"}
              </span>
            </NavLink>
          </div>
        </div>
      </nav>
    );
  }

  // Public (non-authenticated) navbar
  return (
    <nav className="public-nav-v2">
      <div className="public-nav-v2-content">
        <NavLink to="/" className="public-nav-v2-logo">
          <img
            src={`${process.env.PUBLIC_URL}/images/logo_dark_blue.svg`}
            alt="Plaintr"
            height="30"
          />
        </NavLink>

        <button
          className="public-nav-v2-menu-icon"
          onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
          aria-label="Open menu"
        >
          <img
            src={`${process.env.PUBLIC_URL}/images/icons/burger_menu_black.svg`}
            alt="Open menu"
          />
        </button>

        <div
          className={`public-nav-v2-menu ${isMobileMenuOpen ? "open" : ""}`}
          onClick={() => setIsMobileMenuOpen(false)}
        >
          <div
            className="public-nav-v2-menu-content"
            onClick={(e) => e.stopPropagation()}
          >
            <button
              className="public-nav-v2-menu-close"
              onClick={() => setIsMobileMenuOpen(false)}
              aria-label="Close menu"
            >
              <img
                src={`${process.env.PUBLIC_URL}/images/icons/close_menu_black.svg`}
                alt="Close menu"
              />
            </button>
            <div className="public-nav-v2-menu-links">
              <NavLink
                to="/services"
                className="public-nav-v2-link"
                onClick={() => setIsMobileMenuOpen(false)}
              >
                <b>{content.pub.link1.text}</b>
              </NavLink>
              <NavLink
                to="/who-we-help"
                className="public-nav-v2-link"
                onClick={() => setIsMobileMenuOpen(false)}
              >
                <b>{content.pub.link2.text}</b>
              </NavLink>
              <NavLink
                to="/blog"
                className="public-nav-v2-link"
                onClick={() => setIsMobileMenuOpen(false)}
              >
                <b>{content.pub.link3.text}</b>
              </NavLink>
              <NavLink
                to="/sign-in"
                className="cta-button secondary"
                onClick={() => setIsMobileMenuOpen(false)}
              >
                <b>{content.pub.cta_1.text}</b>
              </NavLink>
              <NavLink
                to="/sign-up"
                className="cta-button primary"
                onClick={() => setIsMobileMenuOpen(false)}
              >
                <b>{content.pub.cta_2.text}</b>
              </NavLink>
            </div>
          </div>
        </div>
      </div>
    </nav>
  );
}

export default PublicNavBarV2;
